// @ts-check
import { Component } from 'react';
import { connect } from 'react-redux';

// There is no need for this to be a react component..
class WebappClient extends Component {
  constructor(props) {
    super(props);
    this.state = { pictures: [] };
  }

  _resolveBaseUrl = () => {
    const baseUrl = localStorage.baseUrl || 'https://webapp.iamplooto.com'
    return baseUrl
  }


  async fetchSolutions(queryObj) {
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(queryObj)
    }

    const url = `${this._resolveBaseUrl()}/generate-layout`
    console.log(`sending request to ${url}`)

    const response = await fetch(url, options)
    const solutions = await response.json()
    localStorage.setItem('solutions', JSON.stringify(solutions))
    return solutions
  }


  /**
   * @param {string} userId
   * @param {{
   *  profession: string
   *  industry: string
   *  companyEmployeesNum: number
   *  futureWorkSuggestion?: string
   *  email?: string
   * }} userData
   */
  async createUser(userId, userData) {
    const userDataBody = {
      userData
    }

    const options = {
      method: 'POST',
      headers: {
        'Authorization': userId,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(userDataBody)
    }

    const url = `${this._resolveBaseUrl()}/create-user`
    console.log(`sending request to ${url}`)

    const response = await fetch(url, options)

    console.log(response)
    return response
  }
}

// @ts-ignore
export default connect(null, null)(WebappClient);